import { render, staticRenderFns } from "./main-function.vue?vue&type=template&id=5d02f220&scoped=true"
import script from "./main-function.vue?vue&type=script&lang=js"
export * from "./main-function.vue?vue&type=script&lang=js"
import style0 from "./main-function.vue?vue&type=style&index=0&id=5d02f220&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d02f220",
  null
  
)

export default component.exports